<template>
<div>
  <div class="menu" id="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item> 
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content">
      <iframe frameborder="0" width="100%" height="505" src="http://47.97.5.38:7043/primer3/beina"></iframe>
    </div></div>
</template>
<script>
export default {
    created(){
      window.addEventListener("scroll", this.handleScroll); 
      let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Login expired, please log in again", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }
    },
     methods:{
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#menu").offsetTop;
      let isFixed = scrollTop > offsetTop ? true : false;
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999";
      } else {
        document.querySelector("#menu").style = "";
      }
    },
  }
}
</script>
<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
  .content{
    width: 1200px;
    margin: 0 auto;
    /* min-height: 600px; */
  }
</style>